import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-22ff175e"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode(" pivot ")
const _hoisted_2 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_slider = _resolveComponent("a-slider")!
  const _component_a_input_number = _resolveComponent("a-input-number")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_typography_title = _resolveComponent("a-typography-title")!
  const _component_MediaCards = _resolveComponent("MediaCards")!
  const _component_table_list = _resolveComponent("table-list")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_MediaCards, {
      ref: "mediaCardRef",
      type: [
      { name: 'video', props: { search: true } },
      {
        name: 'image',
        props: { search: true },
      },
      { name: 'ImageCheckCard', props: { search: false } },

      {
        name: 'scenario',
        props: {
          scenarioUrl: _ctx.scenarioUrl,
        },
        event: {
          click: _ctx.onClick,
        },
      },
    ],
      onSelect: _ctx.onSelect
    }, {
      scenariooption: _withCtx(() => [
        _createVNode(_component_a_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_a_col, {
              span: 4,
              style: {"display":"flex","align-items":"center"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_checkbox, {
                  checked: _ctx.pivotCheck,
                  "onUpdate:checked": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.pivotCheck) = $event)),
                  disabled: !_ctx.maxPivotValue
                }, {
                  default: _withCtx(() => [
                    _hoisted_1
                  ]),
                  _: 1
                }, 8, ["checked", "disabled"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_col, { span: 12 }, {
              default: _withCtx(() => [
                _createVNode(_component_a_slider, {
                  value: _ctx.pivotValue,
                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.pivotValue) = $event)),
                  disabled: !_ctx.pivotCheck,
                  min: 0,
                  max: _ctx.maxPivotValue,
                  step: 0.01
                }, null, 8, ["value", "disabled", "max", "step"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_col, { span: 4 }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input_number, {
                  value: _ctx.pivotValue,
                  "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.pivotValue) = $event)),
                  disabled: !_ctx.pivotCheck,
                  min: 0,
                  step: 0.01,
                  max: _ctx.maxPivotValue,
                  style: {"margin-left":"16px"}
                }, null, 8, ["value", "disabled", "step", "max"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      guide: _withCtx(() => [
        _createVNode(_component_a_typography_title, { level: 5 })
      ]),
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("video", {
          src: _ctx.tempVideoUrl,
          onLoadedmetadata: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onLoadVideo && _ctx.onLoadVideo(...args)))
        }, null, 40, _hoisted_2), [
          [_vShow, false]
        ])
      ]),
      _: 1
    }, 8, ["type", "onSelect"]),
    _createVNode(_component_table_list, {
      ref: "tableListRef",
      columns: _ctx.columns,
      "list-columns": [
      {
        title: '영상',
        key: 'clip_name',
      },
      {
        title: 'Image',
        key: 'target_name',
      },
      {
        title: 'Made by',
        key: 'username',
      },
    ],
      apis: { list: _ctx.apiUrl },
      type: "video",
      "table-handler-props": { mode: ['download'] }
    }, null, 8, ["columns", "apis"])
  ], 64))
}